export default {
  provider: state => state.provider,
  activeAnswerItem: state => state.activeAnswerItem,
  editMessage: state => state.editMessage,
  chatUser: state => state.profile,
  selectedMessages: state => state.selectedMessages,
  chatIdForForward: state => state.chatIdForForward,
  choiceForwardIsActive: state => state.choiceForwardIsActive,
  forwardReadyMessages: state => state.forwardReadyMessages,
  imagesGallery: state => state.imagesGallery,
  quantityUsers: state => state.quantityUsers,
  offset: state => state.offset,
  lastChatPage: state => state.lastChatPage,
  chatById: state => id => state.chatList.find(chat => chat.id === id),
  membersByChatId: state => id => {
    let chat = state.chatList.find(chat => chat.id === id)
    return chat ? chat.users : []
  },
  newEventChat: state => {
    return !!state.chatList.find(chat => chat.hasOwnProperty('newMessageNotify') && chat.newMessageNotify === true)
  },
  chatName: state => id => {
    const chat = state.chatList.find(chat => chat.id === id)

    return chat ? chat.name : ''
  },
  activeChat(state) {
    if (state.chatList.length === 0 || !state.idChatActive) {
      return {
        name: null,
      }
    } else {
      return state.chatList.filter(chat => chat.id === state.idChatActive)
    }
  },
  chatMembers(state) {
    if (state.users.length === 0) {
      return []
    } else {
      return state.users.filter(user => state.membersIds.has(user.id))
    }
  },
}
